module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/passthrough.js
// module id = 279
// module chunks = 0